import CustomersCreateQuickFormModal from './CustomersCreateQuickFormModal';

export default CustomersCreateQuickFormModal;
